import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { PRODUCTS } from "../data/site";
import { useReveal } from "../hooks/useReveal";
import SafeImage from "./SafeImage";

export default function Products() {
    const ref = useReveal();
    return (
        <section
            id="products"
            data-testid="products-section"
            className="bg-white py-24 sm:py-32"
        >
            <div className="mx-auto max-w-7xl px-5 sm:px-8 lg:px-10">
                <div ref={ref} className="reveal mb-14 max-w-3xl">
                    <span className="text-xs uppercase tracking-[0.22em] text-brand-red">
                        Our Products
                    </span>
                    <h2 className="mt-3 font-display text-4xl font-bold tracking-[-0.025em] sm:text-6xl">
                        Sourced direct.
                        <br />
                        <span className="text-ink-muted">Graded with care.</span>
                    </h2>
                    <p className="mt-5 max-w-2xl text-ink-muted">
                        Six product lines — red chilli, Guntur Teja, turmeric, coriander, cumin
                        and the wider Indian spices range — all shipped under our IEC, FSSAI
                        and Spices Board export registrations.
                    </p>
                </div>

                <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
                    {PRODUCTS.map((p) => (
                        <ProductCard key={p.id} p={p} />
                    ))}
                </div>
            </div>
        </section>
    );
}

function ProductCard({ p }) {
    const ref = useReveal();
    return (
        <Link
            to={`/products/${p.slug}`}
            ref={ref}
            data-testid={`product-card-${p.id}`}
            className="reveal group flex flex-col overflow-hidden rounded-3xl border border-hairline bg-white transition-shadow hover:shadow-xl"
        >
            <div className="relative aspect-[4/3] w-full overflow-hidden bg-black/5">
                <SafeImage src={p.image} alt={p.name} className="transition-transform duration-700 ease-out group-hover:scale-[1.06]" />
                <span className="absolute left-4 top-4 inline-flex items-center rounded-full bg-white/90 px-3 py-1 text-[11px] font-medium tracking-wide text-ink backdrop-blur">
                    {p.tag}
                </span>
            </div>
            <div className="flex flex-1 flex-col p-6 sm:p-7">
                <div className="flex items-start justify-between gap-4">
                    <h3 className="font-display text-xl font-bold tracking-tight sm:text-2xl">
                        {p.name}
                    </h3>
                    <span className="grid h-9 w-9 shrink-0 place-items-center rounded-full bg-ink text-white transition-transform group-hover:scale-110">
                        <ArrowUpRight className="h-4 w-4" />
                    </span>
                </div>
                <p className="mt-2 text-sm leading-relaxed text-ink-muted">{p.blurb}</p>
                <div className="mt-5 flex flex-wrap gap-1.5">
                    {p.grades.slice(0, 3).map((g) => (
                        <span key={g} className="rounded-full bg-brand-red/8 px-2.5 py-1 text-[11px] font-medium text-brand-red">
                            {g}
                        </span>
                    ))}
                </div>
            </div>
        </Link>
    );
}
